import React from 'react';
import PropTypes from 'prop-types';
import '../stylesheets/sk-wave.css';

const Loader = (props) => {
  const { centered } = props;
  return (
    <div className={`${centered ? 're is-flex is-justifyContent-center' : ''}`}>
      <div className="sk-wave">
        <div className="sk-rect sk-rect1" />
        <div className="sk-rect sk-rect2" />
        <div className="sk-rect sk-rect3" />
        <div className="sk-rect sk-rect4" />
        <div className="sk-rect sk-rect5" />
      </div>
    </div>
  );
};

Loader.propTypes = {
  centered: PropTypes.bool,
};

Loader.defaultProps = {
  centered: undefined,
};

export default Loader;
